import React from 'react';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { VACANCY_GROUP_PATH } from 'domain/recruiting/newVacancy/routing';
import { VacancyGroupType } from 'domain/shared/newVacancy';

const CandidateVacancySpecialization = ({ vacancyData }: { vacancyData: VacancyGroupType }) => {
  const { id, specialization, details } = vacancyData;
  return (
    <Box sx={{ padding: '0px', display: 'flex', alignItems: 'center' }}>
      <Typography
        component={Link}
        key={specialization + id}
        to={`${VACANCY_GROUP_PATH}/${id}`}
        title={specialization}
        sx={{ fontWeight: 400, fontSize: '14px', lineHeight: '17.07px' }}
      >
        {details.competencyLevelMin} {specialization}
      </Typography>
    </Box>
  );
};

export default CandidateVacancySpecialization;
